import React, { useState, useEffect } from "react";
import Modal from "../../components/Modal";
import { DepartmentFormData } from "../../interfaces/departments";
import { createDepartment, updateDepartment } from "../../apis/departments";

interface Props {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
  editableId?: number | null;
  departmentData?: DepartmentFormData | null;
}

const AddDepartmentModal: React.FC<Props> = ({
  open,
  onClose,
  onSuccess,
  editableId,
  departmentData,
}) => {
  const defaultDepartment: DepartmentFormData = {
    name: "",
  };

  const [department, setDepartment] =
    useState<DepartmentFormData>(defaultDepartment);

  const isEditMode = Boolean(editableId);

  const generateDepartmentCode = (name: string): string => {
  return name
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_")     // space -> underscore
    .replace(/[^\w_]/g, "");  // special characters remove
};

  useEffect(() => {
    if (open) {
      if (isEditMode && departmentData) {
        setDepartment(departmentData);
      } else {
        setDepartment(defaultDepartment);
      }
    }
  }, [open, editableId, departmentData]);
  const handleSave = async () => {
  if (!department.name.trim()) return alert("Name required");
  const payload = {
    ...department,
    code: generateDepartmentCode(department.name),
  };
  try {
    if (isEditMode) {
      await updateDepartment(editableId!, payload);
    } else {
      await createDepartment(payload);
    }

    onSuccess();
    onClose();
  } catch (error) {
    console.log("Error saving department:", error);
  }
};

  if (!open) return null;

  return (
    <Modal
      title={isEditMode ? "Edit Department" : "Add Department"}
      onClose={onClose}
      modalContent={
        <div className="space-y-4">
          <div>
            <label>Name</label>
            <input
              type="text"
              value={department.name}
              onChange={(e) =>
                setDepartment({ ...department, name: e.target.value })
              }
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm"
            />
          </div>

          <div className="flex justify-end gap-2">
            <button
              onClick={handleSave}
              className="px-3 py-2 bg-primary text-white rounded"
            >
              {isEditMode ? "Update" : "Save"}
            </button>

            <button
              onClick={onClose}
              className="px-3 py-2 border rounded"
            >
              Cancel
            </button>

          </div>
        </div>
      }
    />
  );
};

export default AddDepartmentModal;
